import { call, put, takeEvery, all } from "redux-saga/effects"
import { Record } from "immutable"
import { getTableData, deleteItemsRequest } from "../api"
import { appName } from "../constants"

/**
 * Constants
 * */
export const moduleName = "inventories"
const prefix = `${appName}/${moduleName}`

export const TABLE_DATA_REQUEST = `${prefix}/TABLE_DATA_REQUEST`
export const TABLE_DATA_SUCCESS = "TABLE_DATA_SUCCESS"
export const TABLE_DATA_ERROR = "TABLE_DATA_ERROR"

export const REMOVE_ITEM_REQUEST = `${prefix}/REMOVE_ITEM_REQUEST`
export const REMOVE_ITEM_SUCCESS = "REMOVE_ITEM_SUCCESS"
export const REMOVE_ITEM_ERROR = "REMOVE_ITEM_ERROR"

/**
 * Reducer
 * */

export const ReducerRecord = Record({
  inventories: null,
  loading: false,
  loaded: false,
  tableLoaded: true
})

export default function reducer(state = new ReducerRecord(), action) {
  const { type, payload } = action

  switch (type) {
    case TABLE_DATA_REQUEST:
      return state.set("loading", true).set("loaded", false)
    case TABLE_DATA_SUCCESS:
      return state
        .set("loading", false)
        .set("loaded", true)
        .set("inventories", payload)

    default:
      return state
  }
}

/**
 * Selectors
 * */

export const inventoriesSelector = (state) => state

/**
 * Action Creators
 * */


export const getInventories = (url) => {
  return {
    type: TABLE_DATA_REQUEST,
    payload: url
  }
}

const inventoriesToSuccess = (data) => ({ type: TABLE_DATA_SUCCESS, payload: data })

const inventoriesWithError = (error) => ({ type: TABLE_DATA_ERROR, ...error })

// Removing items
export const deleteItems = (tableItems, currentPageLocation) => {
  return {
    type: REMOVE_ITEM_REQUEST,
    payload: {
      tableItems,
      currentPageLocation
    }
  }
}

const deleteItemsToSuccess = (data) => ({ type: REMOVE_ITEM_SUCCESS, payload: data })

const deleteItemsWithError = (error) => ({ type: REMOVE_ITEM_ERROR, ...error })

/**
 * Sagas
 **/

function* inventoriesData(action) {
  try {
    const result = yield call(() => {
      return getTableData(action.payload)
    })

    yield put(inventoriesToSuccess(result.data))
  } catch (error) {
    yield put(inventoriesWithError(error))
  }
}

function* inventoriesRemoveItem(action) {
  try {
    const result = yield call(() => {
      return deleteItemsRequest(`/etl/inventories?${action.payload.tableItems}`)
    })

    yield put(deleteItemsToSuccess(result.data))

    yield put(getInventories(`/etl/inventories${action.payload.currentPageLocation}`))
  } catch (error) {
    yield put(deleteItemsWithError(error))
  }
}

export function* saga() {
  yield all([takeEvery(TABLE_DATA_REQUEST, inventoriesData),
                    takeEvery(REMOVE_ITEM_REQUEST, inventoriesRemoveItem)])
}
